module.exports = __webpack_public_path__ + "static/media/edit.11f1c811.svg";